import {
  CHANGE_GLOBAL_STATE,
  CHANGE_ERROR_DATA,
  CHANGE_LOADING_DATA,
  SET_IND_VALIDACION,
  SHOW_MODAL_LOADING,
  SET_VIEW_MODAL_ERROR,
  SET_RELATIONSHIP_LIST,
  SET_PAYMENT_SUBSCRIBED,
  SET_IS_FIRST_TIME_VIEWING_PLANS,
} from "../types/global";
import { StateMachine } from "../../utils/consts";

export const changeGlobalState = (state) => ({
  type: CHANGE_GLOBAL_STATE,
  payload: StateMachine[state],
});
export const changeLoadingData = (loading) => ({
  type: CHANGE_LOADING_DATA,
  payload: loading,
});
export const changeErrorData = (error) => ({
  type: CHANGE_ERROR_DATA,
  payload: error,
});
export const changeIndValidacion = (error) => ({
  type: SET_IND_VALIDACION,
  payload: error,
});
export const showModalLoading = (message) => ({
  type: SHOW_MODAL_LOADING,
  payload: message,
});
export const setViewModalError = (view) => ({
  type: SET_VIEW_MODAL_ERROR,
  payload: view,
});
export const setRelationshipList = (list) => ({
  type: SET_RELATIONSHIP_LIST,
  payload: list,
});
export const setPaymentSuscribed = (isSuscribed) => ({
  type: SET_PAYMENT_SUBSCRIBED,
  payload: isSuscribed,
});
export const setIsFirstTimeViewingPlans = (isFirstTime) => ({
  type: SET_IS_FIRST_TIME_VIEWING_PLANS,
  payload: isFirstTime,
})
